export class Ledgerentries {
    Id :Number ;
    TransactionId :Number ;
    LedgerId :Number ;
    Particulars :string ;
    EntryType :string ;
    Amount :Number ;
    Remarks :string ;
    PersonId :Number ;
    CostCentreId :Number ;
    CreatedDate :Date ;

    FromDate :Date;
    ToDate: Date;

     VoucherTypeId : Number; /// for auto selection ledger
     Isopening : Boolean;  // for opening balance
     IsDayClose: Boolean;
     TotalAmount: Number;
     LedgerName: string ;
}
